import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { StyledClientFilterItem } from "views/Tasks/styles";
import ClientTraceSyncStatus from "./clientTraceSyncStatus";
import { useSearchParams } from "react-router-dom";
import ClientTanSyncStatus from "./clientTanSyncStatus";

const TanClientAutoStatus = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "tanSyncStatus";
  const [active, setActive] = useState(defaultTab);

  useEffect(() => {
    setActive(defaultTab);
  }, [defaultTab]);

  const handleTabChange = (tab: string) => {
    setActive(tab);
    setSearchParams({ tab }); // Update URL query param
  };

  return (
    <Box pl={1} pr={1} mt={0} pt={0}>
      <Box
        pl={2}
        pr={2}
        mb={0}
        mt={0}
        pt={0}
        pb={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box display="flex" gap="15px" flexWrap="wrap" alignItems="center">
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "tanSyncStatus" ? 1 : 0}
            onClick={() => handleTabChange("tanSyncStatus")}
          >
            TAN
          </StyledClientFilterItem>
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "tracesSyncStatus" ? 1 : 0}
            onClick={() => handleTabChange("tracesSyncStatus")}
          >
            Trace
          </StyledClientFilterItem>
        </Box>
      </Box>
      {active === "tanSyncStatus" && <ClientTanSyncStatus tab="tanSyncStatus" />}
      {active === "tracesSyncStatus" && <ClientTraceSyncStatus tab="tracesSyncStatus" />}
    </Box>
  );
};

export default TanClientAutoStatus;
